import * as React from "react"
import {useEffect, useMemo} from "react"
import {useDispatch, useSelector} from "react-redux"
import {useHistory} from "react-router-dom"
import {StateType} from "../../store/store"
import {getCompanies, setCompanies} from "../../store/companyReducer"
import {useFormik} from "formik"
import {Helmet} from "react-helmet-async"
import {Button, Form} from "antd"
import {BackButton} from "../../components/BackButton/BackButton"
import {FormInput} from "../../components/Form/FormInput"
import {ID_SYSTEM_COMPANY} from "../../constants/constants"
import {FormSelect} from "../../components/Form/FormSelect"
import {uinRequest} from "../../models/request/UinRequest"
import {createUin} from "../../store/uinListReducer"
import {useGetCompanies} from "../../hooks/useFetchHooks"

export const UinListForm = () =>
{
    const dispatch = useDispatch()
    const history = useHistory()
    const profile = useSelector((state: StateType) => state.appReducer.profile)
    const status = useSelector((state: StateType) => state.appReducer.status)
    const getCompanyParams = useMemo(() => ({excludeSystem: true}), [])
    const companies = useGetCompanies(getCompanyParams)
    const controller = useMemo(() => new AbortController(), [])

    useEffect(() =>
    {
        dispatch(getCompanies({excludeSystem: true, controller}))

        return () =>
        {
            controller.abort()
            dispatch(setCompanies(null))
        }
    }, [dispatch, controller])

    const formik = useFormik({
        initialValues: {
            uin: "",
            idCompany: null,
        },
        validationSchema: uinRequest,
        onSubmit: async (values) =>
        {
            const {payload}: any = await dispatch(createUin({
                uin: values.uin,
                idCompany: values.idCompany || 0,
                controller,
            }))

            if (payload?.status === 0) history.goBack()
        },
    })
    const {values, handleChange, handleBlur, handleSubmit, errors, touched, setFieldValue} = formik

    const companyOptions = useMemo(() => companies?.data?.map(i => ({label: i.name, value: i.id})) || [], [companies])

    return (
        <div className="form-page">
            <Helmet>
                <title>Новый UIN</title>
            </Helmet>
            <Form className="form-container"
                  autoComplete="off"
                  onSubmitCapture={handleSubmit}
            >
                <div className="description-header"><BackButton onClick={() => history.goBack()}/></div>

                <div className="description-title">Новый UIN</div>

                {
                    profile?.idCompany === ID_SYSTEM_COMPANY
                        ? <FormSelect placeholder="Компания"
                                      value={values.idCompany}
                                      onChange={(value) => setFieldValue("idCompany", value)}
                                      options={companyOptions}
                                      className="form-select"
                                      isInvalid={touched.idCompany && errors.idCompany}
                        />
                        : null
                }

                <FormInput placeholder="UIN"
                           value={values.uin}
                           name="uin"
                           onBlur={handleBlur}
                           onChange={handleChange}
                           isInvalid={touched.uin && errors.uin}
                           allowClear
                />

                <div className="form-button-block">
                    <Button type="primary"
                            htmlType="submit"
                            loading={status === "loading"}
                    >
                        Сохранить
                    </Button>
                    <Button type="default"
                            onClick={() => history.goBack()}
                    >
                        Отмена
                    </Button>
                </div>
            </Form>
        </div>
    )
}